/***************************************************************
2/5/2020
Alexander Self
fert_applied_table.js
- Displays a list of fertilizers applied
***************************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { sumProp } from '../../../harvest_utils';

const propTypes = {
  chemicalList: PropTypes.array,
  readOnly: PropTypes.bool,
  solutions: PropTypes.array,
  edit: PropTypes.func,
  _delete: PropTypes.func
};

const FertAppliedTable = ({ fertilizers, chemicalList, _edit, _delete, readOnly }) => {
  if (!fertilizers) return <span></span>;
  if (readOnly) {
    return (
      <table className="bordered highlight responsive-table centered">
        <thead>
          <tr>
            { fertilizers.length > 0 ?
                fertilizers[0].hasOwnProperty('date') ?
                <th>Date</th> : <th>Id</th>
                : <th>Id</th>
            }
            <th>Fertilizer</th>
            <th>Field</th>
            <th>Hours</th>
            <th>Acres Completed</th>
            <th>Acres Balance</th>
            <th>Quantity / Unit</th>
            <th>Acres / Hour</th>
            <th>Quantity / Acre</th>
            <th>Quantity / Hour</th>
          </tr>
        </thead>
        <tbody>
          {
            fertilizers.map((s, i) => {
              let chem = chemicalList.find((c) => c.id === Number(s.chemId));
              return (
                <tr key={`${s.id}${Math.random()}`}>
                  { fertilizers.length > 0 ?
                      fertilizers[0].hasOwnProperty('date') ?
                      <td>{ moment(s.date).format('YYYY-MM-DD') }</td> : <td>{ s.id }</td>
                      : <td>{ s.id }</td>
                  }
                  <td>{ chem.name ? chem.name : '' } - { chem.type }</td>
                  <td>{ s.field }</td>
                  <td>{ s.hours }</td>
                  <td>{ s.acresCompleted }</td>
                  <td>{ s.acresBalance < 0 ? <span className="red-text">{ s.acresBalance }</span> : <span>{ s.acresBalance }</span> }</td>
                  <td>{ s.quantityApplied } { s.unitOfMeasure }</td>
                  <td>{ s.acresPerHour }</td>
                  <td>{ s.quantityPerAcre }</td>
                  <td>{ s.quantityPerHour }</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot>
          <tr>
            <td><center>Totals</center></td>
            <td><b><center></center></b></td>
            <td><b><center></center></b></td>
            <td><b><center>{ fertilizers.find((f) => f.appType === 'L') ? Math.max(...fertilizers.map((f) => f.hours)) : sumProp('hours', fertilizers) }</center></b></td>
            <td><b><center>{ fertilizers.find((f) => f.appType === 'L') ? Math.max(...fertilizers.map((f) => f.acresCompleted)) : sumProp('acresCompleted', fertilizers) }</center></b></td>
          </tr>
        </tfoot>
      </table>
    )
  }
  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr className={'fert-th'}>
          <th>Fertilizer</th>
          <th>Field</th>
          <th>Hours</th>
          <th>Acres Completed</th>
          <th>Quantity / Unit</th>
          <th>Acres / Hour</th>
          <th>Quantity / Acre</th>
          <th>Quantity / Hour</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          fertilizers.map((s, i) => {
            let chem = chemicalList.find((c) => c.id === Number(s.chemId));
            return (
              <tr className={'fert-td'} key={s.id}>
                <td>{ chem.name } - { chem.type }</td>
                <td>{ s.field }</td>
                <td>{ s.hours }</td>
                <td>{ s.acresCompleted }</td>
                <td>{ s.quantityApplied } { s.unitOfMeasure }</td>
                <td>{ s.acresPerHour }</td>
                <td>{ s.quantityPerAcre }</td>
                <td>{ s.quantityPerHour }</td>
                <td>
                  <button onClick={() => _edit({fertilizer: s, formId: s.formId})} className="btn-floating waves-effect waves-light blue table-btn">
                    <i className="material-icons">mode_edit</i>
                  </button>
                </td>
                <td>
                  <button onClick={() => _delete({fertilizer: s})} className="btn-floating waves-effect waves-light red table-btn">
                    <i className="material-icons">clear</i>
                  </button>
                </td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center>Totals</center></td>
          <td><b><center></center></b></td>
          <td><b><center>{ fertilizers.find((f) => f.appType === 'L') ? Math.max(...fertilizers.map((f) => f.hours)) : sumProp('hours', fertilizers) }</center></b></td>
          <td><b><center>{ fertilizers.find((f) => f.appType === 'L') ? Math.max(...fertilizers.map((f) => f.acresCompleted)) : sumProp('acresCompleted', fertilizers) }</center></b></td>
        </tr>
      </tfoot>
    </table>
  )
};

FertAppliedTable.propTypes = propTypes;
export default FertAppliedTable;



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fert_applied_table.js